function normalize(config, planIterations) {
  const out = {
    interval: config.interval ?? undefined,
    intervalCount: config.intervalCount ?? undefined,
    trialPeriodDays: config.trialPeriodDays ?? undefined,
    billingCycleAnchorConfig: config.billingCycleAnchorConfig ?? undefined,
    startDate: config.startDate ?? undefined,
  };
  if (planIterations != null) out.planIterations = planIterations;
  return out;
}

export default function getPriceBillingConfig(price) {
  if (!price) return null;
  if (price.recurring) return normalize(price.recurring);
  if (price.paymentPlan) return normalize(price.paymentPlan, price.paymentPlan.planIterations);

  return null;
}
